import { render, staticRenderFns } from "./svg-star.vue?vue&type=template&id=26f2929e&"
import script from "./svg-star.vue?vue&type=script&lang=js&"
export * from "./svg-star.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports